<template>
	<div>
		<el-table :data="tableData" show-summary :summary-method="getSummaries">
			<el-table-column label="Code" width="200">
				<template slot-scope="scope">
					<el-input v-model="scope.row.code"></el-input>
				</template>
			</el-table-column>

			<el-table-column label="Description" width="200">
				<template slot-scope="scope">
					<el-input v-model="scope.row.description"></el-input>
				</template>
			</el-table-column>

			<el-table-column prop="current_outstanding" sortable width="150px" :formatter="formatCurrency"
				label="Current Outstanding">
				<template slot="header" slot-scope="scope">
					<span class="text-break">{{ scope.column.label }}</span>
				</template>
				<template slot-scope="scope">
					<el-input v-model="scope.row.current_outstanding"></el-input>
				</template>
			</el-table-column>

			<el-table-column prop="amount" sortable width="150px" :formatter="formatCurrency"
				label="Current Installment">
				<template slot="header" slot-scope="scope">
					<span class="text-break">{{ scope.column.label }}</span>
				</template>
				<template slot-scope="scope">
					<el-input v-model="scope.row.amount"></el-input>
				</template>
			</el-table-column>

			<el-table-column prop="special_settlement" sortable width="150px" :formatter="formatCurrency"
				label="Special Settlement">
				<template slot="header" slot-scope="scope">
					<span class="text-break">{{ scope.column.label }}</span>
				</template>
				<template slot-scope="scope">
					<el-input :disabled="scope.row.is_consolidate"
						v-model="scope.row.special_settlement"></el-input>
				</template>
			</el-table-column>
			
			<el-table-column prop="consolidate_settlement" width="190" label="Consolidate Settlement">
				<template slot="header" slot-scope="scope">
					<span class="text-break">{{ scope.column.label }}</span>
				</template>
				<template slot-scope="scope">
					<el-input :disabled="scope.row.is_consolidate" v-model="scope.row.consolidate_settlement"></el-input>
				</template>
			</el-table-column>

			<el-table-column width="auto">
				<template slot-scope="scope">
					<el-switch v-model="scope.row.is_consolidate" active-color="#13ce66" @change="setConsolidate(scope.$index,scope.row)"></el-switch>
				</template>
			</el-table-column>

			<el-table-column label="New Installment" prop="new_instalment" sortable width="160px">
				<template slot="header" slot-scope="scope">
					<span class="text-break">{{ scope.column.label }}</span>
				</template>
				<template slot-scope="scope">
					<el-input v-model="scope.row.new_instalment"></el-input>
				</template>
			</el-table-column>

			<el-table-column label="Action">
				<template slot-scope="scope">
						<el-button 
								@click="deleteItem(!_gHlp.isEmpty(scope.row.customer_tax_deduction_id) ? scope.row.customer_tax_deduction_id : null,scope.$index)"
								type="danger" 
								icon="el-icon-close"
								size="mini" 
								circle
								class="p-0"
						></el-button>
				</template>
			</el-table-column>
		</el-table>
		<el-button type="text" @click="addItem">+ Add Payslip Deduction</el-button>
		<div class="mt-3">
			<b-row class="d-flex justify-content-center">
				<b-col cols="6" md="3">
					<el-button class="bg-primary text-white w-100" @click="saveTable" :loading="is_loading">Save
					</el-button>
				</b-col>
			</b-row>
		</div>
	</div>
</template>
<script>
import { Button, Table, TableColumn, Input, Switch } from 'element-ui'
import { mapState, mapActions } from 'pinia'
import { useCustomerStore } from '@/stores/customerStore'
import { useCreditReportStore } from '@/stores/creditReportStore'
import solutionEventBus from '@/assets/js/EventBus/solutionEventBus.js'

export default {
	props: ['commitments', 'tables'],
	components: {
		[Switch.name]: Switch,
		[Button.name]: Button,
		[Table.name]: Table,
		[TableColumn.name]: TableColumn,
		[Input.name]: Input
	},
	data() {
		return {
			current_tax_deduction:null,
			is_loading: false,
			tableData: [],
			deleteIds:[]
		}
	},
	computed: {
		...mapState(useCustomerStore, ['current_customer']),
	},
	watch: {
		current_customer: {
			handler(newVal) {
				if(newVal){
					this.setTable()
				}
			}
		}
	},
	created() {
		this.setTable()
	},
	methods: {
		...mapActions(useCustomerStore, ['saveAllTaxDeduction']),
		setTable() {
			this.deleteIds = [];
			this.tableData = [];
			if (!_gHlp.isEmpty(this.current_customer)) {
				const incomeMain = this.current_customer.incomes;
				this.current_tax_deduction = incomeMain.main.tax_deduction;

				if (!_gHlp.isEmpty(incomeMain) && !_gHlp.isEmpty(incomeMain.other_tax_deduction)) {
					const payslipDeductionsList = incomeMain.other_tax_deduction;
					
					this.tableData = payslipDeductionsList.map(x => {
						//MODIF FOR SWITCH ELEMENT
						x.is_consolidate = x.is_consolidate == 1 ? true : false;
						return x;
					});
					console.log(this.tableData);
				}
			}
		},
		addItem() {
			this.tableData.push({
				customer_id: this.current_customer.customer_id,
				amount: null, 
				code: null, 
				description: null, 
				special_settlement: null,
				consolidate_settlement: null,
				new_instalment: null,
			})
		},
		saveTable(){
			this.is_loading = true;
			Promise.all([
					this.saveAllTaxDeduction(this.current_customer.customer_id, this.current_tax_deduction, this.tableData),
					// this.deleteAngkasaItems(this.deleteIds)
			]).then(res=>{
				_gNotif.notifySuccess('<b>Payslip Deduction Items</b> - Successfully Updated.');
				solutionEventBus.$emit('refresh-ctos')
				this.is_loading = false;
			}).catch(e => {
				this.is_loading = false
				_gNotif.errorFunction(e)
			});
    },
		deleteItem(id, index){
			if(!_gHlp.isEmpty(id)){
				this.deleteIds.push(id);
			}
			this.tableData.splice(index,1);
		},
		// setConsolidate(index,item){
		// 	if(item.is_consolidate){
		// 		item.consolidate_settlement = item.amount;
		// 		// item.special_settlement = item.amount;
		// 		this.tableData[index] = item;
		// 	}
		// },
		setConsolidate(index,item){
			if(item.is_consolidate){
				item['consolidate_settlement_prev'] = item.consolidate_settlement;
				item['new_instalment_prev'] = item.new_instalment;

				item.consolidate_settlement = item.current_outstanding;
				item.new_instalment = 0;
			}else{
				if(!_gHlp.isEmpty(item.consolidate_settlement_prev)){
					item.consolidate_settlement = item.consolidate_settlement_prev
				}
				if(!_gHlp.isEmpty(item.new_instalment_prev)){
					item.new_instalment = item.new_instalment_prev
				}
			}
			this.tableData[index] = item;
		},
		getSummaries(param) {
			const { columns, data } = param;
			const sums = [];
			columns.forEach((column, index) => {
				if (index === 0) {
					sums[index] = 'Summary';
					return;
				}
				const values = data.map(item => Number(item[column.property]));
				if (!values.every(value => isNaN(value))) {
					const total = values.reduce((prev, curr) => {
						const value = Number(curr);
						if (!isNaN(value)) {
							return prev + curr;
						} else {
							return prev;
						}
					}, 0);

					sums[index] = 'RM ' + total.toLocaleString('en-MY', { minimumFractionDigits: 2 });
				} else {
					sums[index] = '';
				}
			});

			return sums;
		},
		formatCurrency(row, column, cellValue) {
			return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'MYR' }).format(cellValue);
		},
	}
}
</script>